import _curry1 from './private/curry1.js';
const filterNum = _curry1( (str) => {
	let result = str.match(/\d/g);
  	return result ? result.join('') : ''
});
export default filterNum;


// WEBPACK FOOTER //
// ./src/common/bare-metal/filterNum.js